import { supabase } from '../clients/supabaseClient';
import type { Picker } from '../types';

const PICKER_SELECT = `*, store:stores (id, name)`;

export async function fetchPickersFromDb(): Promise<Picker[]> {
    const { data, error } = await supabase
        .from('pickers')
        .select(PICKER_SELECT)
        .is('deleted_at', null)
        .order('first_name');

    if (error) throw error;
    return (data ?? []) as Picker[];
}

export async function createPickerInDb(
    picker: Pick<Picker, 'first_name' | 'last_name' | 'store_id'>
): Promise<Picker> {
    const { data, error } = await supabase
        .from('pickers')
        .insert([{
            first_name: picker.first_name.trim(),
            last_name:  picker.last_name.trim(),
            store_id:   picker.store_id,
        }])
        .select(PICKER_SELECT)
        .single();

    if (error) throw error;
    return data as Picker;
}

export async function deletePickerFromDb(pickerId: string): Promise<void> {
    const { error } = await supabase
        .from('pickers')
        .update({ deleted_at: new Date().toISOString() })
        .eq('id', pickerId);

    if (error) throw error;
}